//  import {
//   FaInstagram,
//   FaDribbble,
//   FaXTwitter,
//   FaYoutube,
// } from "react-icons/fa6";
import { Fragment } from "react";

export function Footer() {
  // const socialLinks = [
  //   { label: "YouTube", icon: FaYoutube },
  //   { label: "Instagram", icon: FaInstagram },
  //   { label: "Twitter", icon: FaXTwitter },
  //   { label: "Dribbble", icon: FaDribbble },
  // ];

  /* const links = [
    [
      { label: "Company", key: "header-1" },
      { label: "Contact us", key: "item-1-3" },
      { label: "Pricing", key: "item-1-4" },
      { label: "Testimonials", key: "item-1-5" },
    ],
    [
      { label: "Support", key: "header-2" },
      { label: "Terms of service", key: "item-2-2" },
      { label: "Legal", key: "item-2-3" },
      { label: "Privacy policy", key: "item-2-4" },
    ],
  ]; */

  return (
    <Fragment>
      <div className="max-w-full mt-8 font-nunito h-auto bg-primary-500">
        
        <div
          className="text-sm  text-center
        {/*grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 justify-items-stretch  text-white*/} p-2"
        >
          <div className="text-white tracking-wide">
            <div className="text-sm">
              <span>This site is developed and maintained by a freelancer.</span>
              <span>All rights reserved</span>
            </div>
            <div className="text-white tracking-wide">
              <div className="text-sm text-blue-900 hover:underline hover:bg-white cursor-pointer">
                <a href="/PrivacyStatement">Privacy Policy </a>
                <a href="./TermsConditions"> | Terms & Conditions </a>
                <a href="./ContactUs">| Contact Us</a>
              </div>
            </div>
            
          </div>
          {/*
          <div className="footer-icons flex items-center justify-center space-x-3">
              {socialLinks.map((socialLink, index) => {
                const Icon = socialLink.icon;
                return <Icon key={`social-${index}`} className="w-6 h-6 p-1 rounded-full bg-primary-500 hover:bg-white hover:text-black cursor-pointer" />;
              })}
            </div>
          <div className="mx-auto grid w-full py-0 grid-cols-2 ">
            {links.map((col, index) => {
              return (
                <ul className={`col col-${index + 1}`} key={`col-${index}`}>
                  {col.map((link, index) => {
                    return (
                      <li
                        key={`link-${col}-${index}`}
                        className={`text-gray-400 cursor-pointer ${
                          link.key === "header-1" || link.key === "header-2"
                            ? "text-xs text-orange-50"
                            : ""
                        }`}
                      >
                        {link.label}
                      </li>
                    );
                  })}
                </ul>
              );
            })}
          </div>
          <div className="footer-form flex flex-col  ">
            <label className="text-xs font-semibold text-orange-50">
              Stay up to date
            </label>
            <input
              type="email"
              placeholder="Subscribe to our email"
              className="mt-2 w-full border-none rounded-lg py-3 px-6"
            />
          </div>
          */}
        </div>
      </div>
    </Fragment>
  );
};

